import { apiClient } from './api';

export interface WarehouseStats {
  orders_to_pick: number;
  orders_packed_today: number;
  low_stock_items: number;
  damaged_items: number;
  pending_returns: number;
}

export interface PickingItem {
  order_id: number;
  order_number: string;
  item_count: number;
  status: 'pending' | 'in_progress';
  priority: 'high' | 'medium' | 'low';
}

export interface LowStockItem {
  sku_id: number;
  product_name: string;
  current_stock: number;
  min_stock: number;
  severity: 'critical' | 'low';
}

export interface ActivityEntry {
  id: string;
  title: string;
  description: string;
  occurred_at: string;
  author: string;
  kind: 'po' | 'transfer' | 'order' | 'return' | 'adjustment';
}

export interface WarehouseDashboardData {
  stats: WarehouseStats;
  picking_queue: PickingItem[];
  low_stock: LowStockItem[];
  activity: ActivityEntry[];
}

export async function getWarehouseDashboard(): Promise<WarehouseDashboardData> {
  return apiClient.get<WarehouseDashboardData>('/warehouse/dashboard');
}
